
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default defineComponent({
  setup() {
    const store = useStore();
    const router = useRouter();

    const isLogged = computed(() => store.getters.isLoggedIn);
    const userName = computed(() => store.state.nom);
    const userFirstname = computed(() => store.state.prenom);
    const userId = computed(() => store.state.idUtilisateur);
    const userEmail = computed(() => store.state.email);

    const logout = async () => {
      await store.dispatch('logout');
      router.push('/login');
    };


  return {
    isLogged,
    userName,
    userFirstname,
    userId,
    userEmail,
    logout,
  };
},
});
